var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-alert',{staticClass:"text-center",attrs:{"value":!!_vm.message,"type":_vm.alert_type,"dismissible":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }